import script from "./BaseImg.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseImg.vue?vue&type=script&setup=true&lang=ts"

import "./BaseImg.vue?vue&type=style&index=0&id=7cdf0688&scoped=true&lang=css"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cdf0688"]])

export default __exports__